import React, { forwardRef } from "react";
import clsx from "clsx";

import styles from "./formControlLabel.module.scss";

export type FormControlLabelProps = React.HTMLProps<HTMLLabelElement> & {
	control: React.ReactNode;
	label?: string;
	labelStart?: string;
	labelEnd?: string;
	className?: string;
};

/**
 * Label for Switch, Checkbox or Radio.
 */
const FormControlLabel = forwardRef<HTMLLabelElement, FormControlLabelProps>(
	function FormControlLabel(
		{ control, label, className, style, labelStart, labelEnd = label },
		ref,
	) {
		return (
			<label
				ref={ref}
				className={clsx(styles.root, className)}
				style={style}
			>
				{labelStart && (
					<span className={clsx(styles.label, styles.labelStart)}>
						{labelStart}
					</span>
				)}
				{control}
				{labelEnd && (
					<span className={clsx(styles.label, styles.labelEnd)}>
						{labelEnd}
					</span>
				)}
			</label>
		);
	},
);

export default FormControlLabel;
